<template>
    <div class="container">
        <div v-if="shopInfo !== null">
            <modal-x :show="isSelectingTeam" @onclose="isSelectingTeam = false" :content-style="{ maxWidth: '800px' }">
                <h1>Select Team</h1>
                <shops-list :is-select-mode="true" @onselect="onTeamSelected"></shops-list>
            </modal-x>
            <!-- <modal-x :show="isEditingLabel" @onclose="isEditingLabel = false" :content-style="{ maxWidth: '800px' }">
                <label-editor v-if="isEditingLabel" :shop-info="shopInfo"></label-editor>
            </modal-x> -->

            <!-- <modal-x :show="isReplying" @onclose="isReplying = false">
                <paged-reply v-if="isReplying" :to-user-id="shopInfo.shopUserId" page-path="" page-query=""
                    @onpostselect="showPost">
                </paged-reply>
            </modal-x> -->

            <modal-x :show="isSelectingImage" @onclose="isSelectingImage = false">
                <image-list v-if="isSelectingImage" :user-id="shopInfo.shopUserId" @onselect="onImgSelect"></image-list>
            </modal-x>

            <modal-x :show="isSelectingPosts" @onclose="isSelectingPosts = false">
                <post-list v-if="isSelectingPosts" :user-id="shopInfo.shopUserId" @onselect="onPostSelect"></post-list>
            </modal-x>

            <modal-x :show="isEditingPost" @onclose="isEditingPost = false">
                <post-editor v-if="isEditingPost" :user-id="shopInfo.shopUserId"
                    :edit-post-id="editingPostId"></post-editor>
            </modal-x>
            <modal-x :show="isAddingPost" @onclose="isAddingPost = false"
                :content-style="{ maxWidth: '800px', height: 'calc(100% - 40px)', padding: '10px' }">
                <add-post v-if="isAddingPost" @onadded="onPostAdded" :user-id="shopInfo.shopUserId"></add-post>
            </modal-x>

            <!-- <modal-x :show="showCategory" @onclose="showCategory = false"
                :content-style="{ maxWidth: '800px', height: 'calc(100% - 40px)' }">
                <div>Listing Categories</div>
                <category v-if="showCategory" :user-id="shopUserId" :cat-node="filterInfo.listingCatNode"
                    cat-type="listing" :showCheckbox="false" :expandAll="true">
                </category>
            </modal-x> -->

            <modal-x :show="showIndustryCats" @onclose="showIndustryCats = false"
                :content-style="{ maxWidth: '800px', height: 'calc(100% - 40px)' }">
                <div>Industry Categories</div>
                <category v-if="showIndustryCats" :user-id="shopUserId" :cat-node="industryCatNode" cat-type="industry"
                    @catSelected="onIndustrySelected" :expandAll="true">
                </category>
            </modal-x>

            <!-- <modal-x :show="showShopTagCats" @onclose="showShopTagCats = false"
                :content-style="{ maxWidth: '800px', height: 'calc(100% - 40px)', padding: '10px' }">
                <div>Shop Tag Categories</div>
                <category v-if="true" :user-id="shopUserId" :cat-node="shopTagCatNode" cat-type="shopTag" :expandAll="true">
                </category>
            </modal-x> -->

            <div class="row">
                <div class="col-xs-12">
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <div class="row">
                                <div class="col-xs-8">
                                    <h3 class="panel-title">Shop Information</h3>
                                </div>
                                <div class="col-xs-4 text-right">
                                    <div v-if="cpdIsManagers">
                                        <a :href="apiClient.getAbsUrl('/Account/Shops/?sid=') + shopInfo.shopId" target="_blank" class="btn btn-link">
                                            <span>ShopID:{{ shopInfo.shopId }}</span>
                                        </a>
                                        <a :href="apiClient.getAbsUrl('/Account/Users/?uid=') + shopInfo.shopUserId"
                                            target="_blank" class="btn btn-link">
                                            <span class="glyphicon glyphicon-user"></span> User Profile
                                        </a>
                                    </div>
                                    <div v-else>
                                        <span class="label label-info">ShopID: {{ shopInfo.shopId }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="panel-body">
                            <div class="row">
                                <div v-if="cpdIsShopKeeper || cpdIsManagers" class="col-xs-12">
                                    <div class="btn-group">
                                        <button v-if="cpdIsManagers" class="btn btn-default" @click="$router.push({ path: 'shopsettings', query: { userId: shopUserId } })">
                                            <span class="glyphicon glyphicon-cog"></span> Settings
                                        </button>
                                        <button class="btn btn-default" @click="$router.push({ path: '/shopList', query: {} })">
                                            <span class="glyphicon glyphicon-list"></span> {{ lang.common.shops }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-12">
                    <div class="row">
                        <div class="col-xs-12">
                            <div class="panel panel-default">
                                <div class="panel-heading">
                                    <h4 class="panel-title">Quick Actions</h4>
                                </div>
                                <div class="panel-body">
                                    <div class="row">
                                        <div class="col-xs-6 col-sm-3 text-center">
                                            <div @click="isAddingPost = true" class="action-card">
                                                <div class="action-icon pbcss-item-add-logo"></div>
                                                <div class="action-label bg-primary">{{ lang.postList.add }}</div>
                                            </div>
                                        </div>
                                        <div class="col-xs-6 col-sm-3 text-center">
                                            <div @click="$router.push({ path: '/PostList', query: { shopUserId: shopInfo.shopUserId } })" class="action-card">
                                                <div class="action-icon pbcss-items-logo"></div>
                                                <div class="action-label bg-primary">{{ lang.postEditor.posts }}</div>
                                            </div>
                                        </div>
                                        <div class="col-xs-6 col-sm-3 text-center" v-if="cpdIsManagers">
                                            <div @click="openLink(parkingSite)" class="action-card">
                                                <div class="action-icon glyphicon glyphicon-link"></div>
                                                <div class="action-label bg-info">Parking</div>
                                            </div>
                                        </div>
                                        <div class="col-xs-6 col-sm-3 text-center" v-if="cpdIsManagers">
                                            <div @click="openLink('/Shopping/Shop/?scode=' + shopInfo.shopCode)" class="action-card">
                                                <div class="action-icon glyphicon glyphicon-link"></div>
                                                <div class="action-label bg-info">SSR</div>
                                            </div>
                                        </div>
                                        <div class="col-xs-6 col-sm-3 text-center" v-if="cpdIsManagers">
                                        <div @click="$router.push({ path: 'Performance', query: { shopUserId: shopInfo.shopUserId } })" class="action-card">
                                            <div class="action-icon glyphicon glyphicon-stats"></div>
                                            <div class="action-label bg-success">Performance</div>
                                        </div>                                    
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-12">
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <ul class="nav nav-tabs">
                                <li role="presentation" :class="{ active: inView === 'main' }">
                                    <a @click.prevent @click="changeView('main')">{{ lang.common.main }}</a>
                                </li>
                                <li role="presentation" :class="{ active: inView === 'configs' }">
                                    <a @click.prevent @click="changeView('configs')">{{ lang.common.shopConfigs }}</a>
                                </li>
                                <li role="presentation" :class="{ active: inView === 'qa' }">
                                    <a @click.prevent @click="changeView('qa')">{{ lang.common.qaReply }}</a>
                                </li>
                                <li role="presentation" :class="{ active: inView === 'categories' }">
                                    <a @click.prevent @click="changeView('categories')">{{ lang.common.categories }}</a>
                                </li>
                            </ul>
                        </div>
                        <div class="panel-body">
                            <div class="tab-content">
                                <div class="tab-pane fade in active" :class="{ active: inView === 'main' }">
                                    <div v-if="inView === 'main'" class="row">
                                        <div class="col-md-6 col-xs-12">
                                            <div class="form-group">
                                                <label>{{ lang.common.domainName }}</label>
                                                <div class="input-group">
                                                    <input :disabled="disableField" class="form-control" type="text" v-model="shopInfo.domainName" :placeholder="'...'+landingSite" />
                                                    <div class="input-group-addon">
                                                        <span @click="openLink(landingSite)" class="glyphicon glyphicon-link"></span> {{ lang.common.website }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-xs-12">
                                            <div class="form-group">
                                                <label>{{ lang.common.shopName }}</label>
                                                <input :disabled="disableField" class="form-control" type="text" v-model="shopInfo.shopName" />
                                            </div>
                                            <div class="form-group">
                                                <label>{{ lang.common.shopCode }}</label>
                                                <input :disabled="disableField" class="form-control" type="text" v-model="shopInfo.shopCode" placeholder="shop code" />
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-xs-12">
                                            <div class="form-group">
                                                <label>{{ lang.common.shopState }}</label>
                                                <select :disabled="disableField" v-model="shopInfo.stateCode" class="form-control">
                                                    <option value="0">Active</option>
                                                    <option value="1">InActive</option>
                                                    <option value="2">Deleted</option>
                                                    <option value="1000">Limited</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-xs-12" v-if="cpdIsManagers">
                                            <div class="form-group">
                                                <label>Team ID</label>
                                                <div class="input-group">
                                                    <button @click="isSelectingTeam = true" class="btn btn-default">Set Team</button>
                                                    <button @click="shopInfo.teamId = null" class="btn btn-default">Clear</button>
                                                    <input :disabled="true" class="form-control" type="text" v-model="shopInfo.teamId" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xs-12" v-if="cpdIsManagers">
                                            <div class="panel panel-default">
                                                <div class="panel-heading">
                                                    <h4 class="panel-title">Enabled Features</h4>
                                                </div>
                                                <div class="panel-body">
                                                    <div class="row">
                                                        <div class="col-md-6 col-xs-12">
                                                            <h5>Functions</h5>
                                                            <div class="checkbox">
                                                                <label>
                                                                    <input v-model="shopInfo.pickupEnabled" type="checkbox"> Pickup
                                                                </label>
                                                            </div>
                                                            <div class="checkbox">
                                                                <label>
                                                                    <input v-model="shopInfo.ownPickupEnabled" type="checkbox"> OwnPickup
                                                                </label>
                                                            </div>
                                                            <div class="checkbox">
                                                                <label>
                                                                    <input v-model="shopInfo.tagFilterable" type="checkbox"> TagFilter
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6 col-xs-12">
                                                            <h5>Payment Methods</h5>
                                                            <div class="checkbox">
                                                                <label>
                                                                    <input v-model="shopInfo.payPalEnabled" type="checkbox"> PayPal
                                                                </label>
                                                            </div>
                                                            <div class="checkbox">
                                                                <label>
                                                                    <input v-model="shopInfo.payCashEnabled" type="checkbox"> PayCash
                                                                </label>
                                                            </div>
                                                            <div class="checkbox">
                                                                <label>
                                                                    <input v-model="shopInfo.payFpsEnabled" type="checkbox"> PayFps
                                                                </label>
                                                            </div>
                                                            <div class="checkbox">
                                                                <label>
                                                                    <input v-model="shopInfo.payMeEnabled" type="checkbox"> PayMe
                                                                </label>
                                                            </div>
                                                            <div class="checkbox">
                                                                <label>
                                                                    <input v-model="shopInfo.payAtmEnabled" type="checkbox"> PayAtm
                                                                </label>
                                                            </div>
                                                            <div class="checkbox">
                                                                <label>
                                                                    <input v-model="shopInfo.payAliEnabled" type="checkbox"> PayAli
                                                                </label>
                                                            </div>
                                                            <div class="checkbox">
                                                                <label>
                                                                    <input v-model="shopInfo.payWechatEnabled" type="checkbox"> PayWechat
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-xs-12">
                                                            <div class="form-group">
                                                                <label>Represent ShopId</label>
                                                                <input class="form-control" type="text" v-model="shopInfo.repShopId" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xs-12" v-if="cpdIsShopKeeper || cpdIsManagers">
                                            <div class="form-group">
                                                <label>Industry Category</label>
                                                <div>
                                                    <button v-if="cpdIsManagers" class="btn btn-default" @click="selectShopIndustry">
                                                        <span class="glyphicon glyphicon-triangle-bottom"></span>
                                                        <span v-if="shopInfo.mainCat !== null && shopInfo.mainCat.child !== null">
                                                            {{ shopInfo.mainCat.child.name }}
                                                        </span>
                                                        <span v-else>Select Industry</span>
                                                    </button>
                                                    <div v-else class="well">
                                                        <span v-if="shopInfo.mainCat !== null">
                                                            {{ shopInfo.mainCat.parent.name }}/{{ shopInfo.mainCat.child.name }}
                                                        </span>
                                                        <span v-else>No Industry Selected</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xs-12" v-if="cpdIsManagers">
                                            <div class="form-group">
                                                <label>View Type</label>
                                                <select :disabled="disableField" v-model="shopInfo.viewCatId" class="form-control">
                                                    <option v-for="opt in viewOptions" :value="opt.value">{{ opt.name }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-xs-12" v-if="cpdIsManagers">
                                            <div class="row">
                                                <div class="col-md-4 col-xs-12">
                                                    <div class="form-group">
                                                        <label>UI Theme</label>
                                                        <select v-model="shopInfo.uiTheme" class="form-control">
                                                            <option :value="null">default</option>
                                                            <option value="home">home</option>
                                                            <option value="food">food</option>
                                                            <option value="it">it</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-md-4 col-xs-12">
                                                    <div class="form-group">
                                                        <label>Body Columns</label>
                                                        <select v-model="shopInfo.uiBody" class="form-control">
                                                            <option value="">Please Select</option>
                                                            <option value="_oneColumn">Single Column</option>
                                                            <option value="_twoColumn">Dual Column</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-md-4 col-xs-12">
                                                    <div class="form-group">
                                                        <label>Listing Rows</label>
                                                        <select v-model="shopInfo.uiListing" class="form-control">
                                                            <option value="">Please Select</option>
                                                            <option value="_oneInRow">One in row</option>
                                                            <option value="_oneInRowX2">One in row X2</option>
                                                            <option value="_threeInRow">Three in row</option>
                                                            <option value="_twoColumns">Two columns</option>
                                                            <option value="_twoInRow">Two in row</option>
                                                            <option value="_xTwoColumns">X Two columns</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xs-12" v-if="cpdIsShopKeeper || cpdIsManagers">
                                            <div class="form-group">
                                                <label>{{ lang.common.shopIntro }}</label>
                                                <textarea class="form-control" rows="5" v-model="shopInfo.intro"></textarea>
                                            </div>
                                        </div>
                                        <div class="col-xs-12">
                                            <div class="panel panel-default">
                                                <div class="panel-heading">
                                                    <h4 class="panel-title">Shop Logo</h4>
                                                </div>
                                                <div class="panel-body">
                                                    <div class="row">
                                                        <div class="col-xs-12 text-center">
                                                            <img :src="shopInfo.logoPath" class="shop-logo" />
                                                        </div>
                                                        <div class="col-xs-12 text-center" v-if="cpdIsShopKeeper || cpdIsManagers">
                                                            <div class="btn-group">
                                                                <button class="btn btn-default" @click="selectImg(setNewLogo)">
                                    <span class="glyphicon glyphicon-picture"></span> Select Logo
                                </button>
                                                                <button class="btn btn-default" @click="removeLogo">
                                    <span class="glyphicon glyphicon-trash"></span> Remove Logo
                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xs-12 text-center" v-if="cpdIsShopKeeper || cpdIsManagers">
                                            <div class="btn-group">
                                                <button class="btn btn-warning" @click="loadShop">
                                                <span class="glyphicon glyphicon-refresh"></span> Cancel
                                            </button>
                                                <button class="btn btn-primary" @click="updateShop">
                                                <span class="glyphicon glyphicon-save"></span> Update
                                            </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="inView === 'configs'">
                                        <label-editor :shop-info="shopInfo"></label-editor>
                                    </div>
                                    <div v-if="inView === 'qa'">
                                        <paged-reply :to-user-id="shopInfo.shopUserId" page-path="" page-query="" @onpostselect="showPost">
                                        </paged-reply>
                                    </div>
                                    <div v-if="inView === 'categories'">
                                        <category :user-id="shopUserId" :cat-node="filterInfo.listingCatNode" cat-type="listing" :showCheckbox="false" :expandAll="true">
                                        </category>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .panel {
        margin-bottom: 20px;
    }
    .panel-heading {
        padding: 10px 15px;
    }
    .panel-title {
        margin-top: 0;
        margin-bottom: 0;
    }
    .panel-body {
        padding: 15px;
    }
    .nav-tabs {
        border-bottom: 1px solid #ddd;
    }
    .nav-tabs > li > a {
        border: 1px solid transparent;
        border-radius: 4px 4px 0 0;
    }
    .nav-tabs > li.active > a,
    .nav-tabs > li.active > a:hover,
    .nav-tabs > li.active > a:focus {
        color: #555;
        background-color: #fff;
        border: 1px solid #ddd;
        border-bottom-color: transparent;
    }
    .action-card {
        cursor: pointer;
        margin-bottom: 15px;
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 10px;
        transition: all 0.3s ease;
    }
    .action-card:hover {
        background-color: #f5f5f5;
        border-color: #ccc;
    }
    .action-icon {
        width: 80px;
        height: 80px;
        border-radius: 10px;
        background-color: #f8f9fa;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        font-size: 40px;
        color: #555;
        box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    }
    .action-label {
        color: white;
        font-weight: bold;
        padding: 5px;
        margin-top: 5px;
        text-align: center;
        border-radius: 4px;
    }
    .shop-logo {
        max-width: 150px;
        max-height: 150px;
        border: 1px solid #ddd;
        padding: 5px;
        background-color: #fff;
    }
    .btn-group {
        margin: 10px 0;
    }
    .form-group {
        margin-bottom: 15px;
    }
    .checkbox {
        margin-bottom: 10px;
    }
    .well {
        background-color: #f5f5f5;
        border: 1px solid #ddd;
        padding: 10px;
        border-radius: 4px;
    }
</style>
<script>
import imageList from './imageList.vue';
import addPost from './addPost.vue';
import postList from './postList.vue';
import postEditor from './postEditor.vue';
import pagedReply from './pagedReply.vue';
import modalX from '../components/base/ModalX1.vue';
import labelEditor from './labelEditor.vue';
import apis from '../api/extApi.js';
import category from './category.vue';
import shopsList from './shopsList.vue';

export default {
    components: {
        shopsList: shopsList,
        category: category,
        labelEditor: labelEditor,
        imageList: imageList,
        postList: postList,
        postEditor: postEditor,
        modalX: modalX,
        pagedReply: pagedReply,
        addPost: addPost
    },
    props: ["shopUserId"],
    computed: {
        lang: function () {
            return this.$store.getters.lang;
        },
        parkingSite: function () {
            if (this.shopInfo === null) return '';
            return '/site/' + this.shopInfo.shopCode;
        },
        landingSite: function () {
            if (this.shopInfo === null) return '';
            let domainName = this.shopInfo.domainName;
            if (domainName && domainName !== "") {
                return '//' + domainName;
            }
            return this.parkingSite;
        },
        cpdIsManagers: function () {
            var dp = this.dashProfile;
            return dp !== null && (dp.isAdmin === true || dp.isManager === true);
        },
        disableField: function () {
            var dp = this.dashProfile;
            var ret = dp !== null && (dp.isAdmin === true || dp.isManager === true);
            return !ret;
        },
        cpdIsAgent: function () {
            var dp = this.dashProfile;
            return dp !== null && (dp.isAgent === true);
        },
        cpdIsShopKeeper: function () {
            var dp = this.dashProfile;
            return dp !== null && (dp.isShopKeeper === true);
        },
        dashProfile: function () {
            return this.$store.getters.dashProfile;
        },
        cpdShowCategoryButton: function () {
            return this.dashProfile && (!this.dashProfile.hasTeam || this.dashProfile.isAdmin);
        }
    },
        data: function () {
            return {
                shopInfo: null,
                apiClient: apis.api,
                catCodes: apis.api.settings.catCodes,
                uiClient: null,
                //viewOptions corresponse to Enum Nature in NetcoreApi.Models
                viewOptions: [
                    { value: 0, name: "None" },
                    // { value: 1, name: "Display" },
                    // { value: 2, name: "Quotation" },
                    { value: 3, name: "SellGoods" },
                    // { value: 4, name: "Sell Course" },
                    // {1:5, name: "News" },
                    { value: 6, name: "RealProperty" }
                ],
                labels: [],
                cats: [],
                hideList: false,
                hideQas: true,
                bannerCatIds: [],
                isReplying: false,
                isSelectingImage: false,
                isSelectingPosts: false,
                isEditingPost: false,
                isSelectingTeam: false,
                editingPostId: null,
                isAddingPost: false,
                selectedImgs: [],
                imgHandler: null,
                newPostData: { title: null, textMsg: null, userId: null },
                bigCatGrp: null,
                isEditingLabel: false,
                filterInfo: null,
                showCategory: false,
                showIndustryCats: false,
                industryCatNode: null,
                //showShopTagCats: false,
                //shopTagCatNode: null,            
                inView: "main"
            }
    },
    methods: {
        changeView: function (newView) {
            this.inView = newView;
        },
        openLink: function (url) {
            window.open(url, '_blank');
        },
        onTeamSelected: function (shop) {
            this.isSelectingTeam = false;
            console.log('team selected', shop);
            this.shopInfo.teamId = shop.shopUserId;
        },
        onPostAdded: function (ret) {
            this.isAddingPost = false;
            this.onPostSelect(ret);
        },
        editListingCat: function () {
            this.showCategory = true;
        },
        onIndustrySelected(catPair) {
            console.log('industry selected', catPair);
            this.shopInfo.mainCat = catPair;
            this.shopInfo.catId = catPair.child.catId;
            this.showIndustryCats = false;
        },
        selectShopIndustry: function () {
            this.showIndustryCats = true;
            this.loadIndustryCats();
        },
        setNewLogo: function (newImg) {
            this.shopInfo.uiLogo = newImg.fileName + newImg.fileType;
            this.shopInfo.logoPath = newImg.thumbPath;
            this.isSelectingImage = false;
        },
        removeLogo: function () {
            this.shopInfo.uiLogo = "";
            this.shopInfo.logoPath = "";
        },
        selectImg: function (handler) {
            this.imgHandler = handler;
            this.isSelectingImage = !this.isSelectingImage;
        },
        onImgSelect: function (imgFile) {
            this.selectedImgs.push(imgFile);
            this.imgHandler(imgFile, this.selectedImgs);
        },
        showPost: function (postId) {
            this.editingPostId = postId;
            this.isEditingPost = true;
        },
        onPostSelect: function (post) {
            this.showPost(post.postId);
        },
        updateShop: function () {
            this.apiClient.updateShopPrms(this.shopInfo).done((ret) => {
                this.shopInfo = ret.value;
            });
        },
        loadShop: function () {
            this.apiClient.getShopViewModelByUidPrms(this.shopUserId).done((ret) => {
                this.shopInfo = ret.value.shop;
                this.filterInfo = ret.value.filterInfo;
            });
        },
        loadIndustryCats() {
            this.apiClient.getCategoryNodePrms(this.catCodes.industry, this.shopUserId).done((ret) => {
                this.industryCatNode = ret;
            });
        }
    },
    mounted: function () {
        this.loadShop();
        this.uiClient = apis.ui.getShopClient({ userId: this.shopUserId });
    },
    created: function () {

    },
    destroyed: function () {
        this.uiClient.destroy();
    }
}
</script>